/** @format */

import {BillingDiscountPeriod} from 'graphql/generated/types';
import {AvailableBusinessTariff} from 'features/tariffs/types';

import {FieldData} from './types';

export const DISCOUNT_PERIODS: Record<BillingDiscountPeriod, BillingDiscountPeriod> = {
  THREE_MONTHS: 'THREE_MONTHS',
  SIX_MONTHS: 'SIX_MONTHS',
  TWELVE_MONTHS: 'TWELVE_MONTHS',
  MONTH: 'MONTH',
};

export const MAX_PAYMENT_IN_RUBLES = 350000;

export const FIELDS_DATA: Record<AvailableBusinessTariff, FieldData> = {
  start: {
    order: 0,
    description: 'Решение для проекта с небольшим рекламным бюджетом',
  },
  active: {
    order: 10,
    description: 'Отличное решение для бизнесов с несколькими рекламными проектами',
  },
  business: {
    order: 20,
    description:
      'Оптимальное управление эффективностью рекламных проектов для серьёзного бизнеса со значительным количеством рекламных проектов',
  },
  premium: {
    order: 30,
    description:
      'Профессиональное решение по управлению эффективностью рекламных проектов для крупного бизнеса',
  },
  ultra: {
    order: 40,
    description:
      'Экспертный уровень управления эффективностью рекламных проектов в промышленных масштабах с персональным подходом',
  },
  pro: {
    order: 0,
    description: '',
  },
  start_trial: {
    order: 0,
    description: '',
  },
};
